export const cashFlowForecastData = {
  // Monthly cash flow forecasts
  monthlyCashFlowForecasts: [
    {
      forecast_id: "cf-forecast-2025-07",
      period: "2025-07",
      forecast_date: "2025-06-15",
      starting_balance: 15250000.00,
      ending_balance: 16100000.00,
      cash_inflows: [
        {
          category: "sales_revenue",
          amount: 8500000.00,
          notes: "預計七月銷售收入"
        },
        {
          category: "accounts_receivable",
          amount: 3200000.00,
          notes: "應收賬款收款"
        },
        {
          category: "investment_income",
          amount: 350000.00,
          notes: "投資收益"
        }
      ],
      cash_outflows: [
        {
          category: "raw_materials",
          amount: 3500000.00,
          notes: "原材料採購"
        },
        {
          category: "payroll",
          amount: 4200000.00,
          notes: "薪資支出"
        },
        {
          category: "rent_utilities",
          amount: 850000.00,
          notes: "租金和水電費"
        },
        {
          category: "taxes",
          amount: 1200000.00,
          notes: "稅款支付"
        },
        {
          category: "loan_payments",
          amount: 1450000.00,
          notes: "貸款還款"
        }
      ],
      net_cash_flow: 850000.00,
      currency: "HKD"
    },
    {
      forecast_id: "cf-forecast-2025-08",
      period: "2025-08",
      forecast_date: "2025-07-15",
      starting_balance: 16100000.00,
      ending_balance: 17250000.00,
      cash_inflows: [
        {
          category: "sales_revenue",
          amount: 8750000.00,
          notes: "預計八月銷售收入"
        },
        {
          category: "accounts_receivable",
          amount: 3500000.00,
          notes: "應收賬款收款"
        },
        {
          category: "investment_income",
          amount: 350000.00,
          notes: "投資收益"
        }
      ],
      cash_outflows: [
        {
          category: "raw_materials",
          amount: 3650000.00,
          notes: "原材料採購"
        },
        {
          category: "payroll",
          amount: 4200000.00,
          notes: "薪資支出"
        },
        {
          category: "rent_utilities",
          amount: 850000.00,
          notes: "租金和水電費"
        },
        {
          category: "taxes",
          amount: 1300000.00,
          notes: "稅款支付"
        },
        {
          category: "loan_payments",
          amount: 1450000.00,
          notes: "貸款還款"
        }
      ],
      net_cash_flow: 1150000.00,
      currency: "HKD"
    },
    {
      forecast_id: "cf-forecast-2025-09",
      period: "2025-09",
      forecast_date: "2025-08-15",
      starting_balance: 17250000.00,
      ending_balance: 18500000.00,
      cash_inflows: [
        {
          category: "sales_revenue",
          amount: 9000000.00,
          notes: "預計九月銷售收入"
        },
        {
          category: "accounts_receivable",
          amount: 3800000.00,
          notes: "應收賬款收款"
        },
        {
          category: "investment_income",
          amount: 350000.00,
          notes: "投資收益"
        }
      ],
      cash_outflows: [
        {
          category: "raw_materials",
          amount: 3800000.00,
          notes: "原材料採購"
        },
        {
          category: "payroll",
          amount: 4200000.00,
          notes: "薪資支出"
        },
        {
          category: "rent_utilities",
          amount: 850000.00,
          notes: "租金和水電費"
        },
        {
          category: "taxes",
          amount: 1600000.00,
          notes: "稅款支付"
        },
        {
          category: "loan_payments",
          amount: 1450000.00,
          notes: "貸款還款"
        }
      ],
      net_cash_flow: 1250000.00,
      currency: "HKD"
    }
  ],

  // Cash flow forecast scenarios
  cashFlowScenarios: [
    {
      scenario_id: "cf-scenario-001",
      scenario_name: "基準情境",
      description: "基於當前市場條件和公司表現的標準預測",
      period_start: "2025-07",
      period_end: "2026-06",
      created_date: "2025-06-01",
      monthly_projections: [
        {
          month: "2025-07",
          net_cash_flow: 850000.00,
          ending_balance: 16100000.00
        },
        {
          month: "2025-08",
          net_cash_flow: 1150000.00,
          ending_balance: 17250000.00
        },
        {
          month: "2025-09",
          net_cash_flow: 1250000.00,
          ending_balance: 18500000.00
        },
        {
          month: "2025-10",
          net_cash_flow: 1300000.00,
          ending_balance: 19800000.00
        },
        {
          month: "2025-11",
          net_cash_flow: 1400000.00,
          ending_balance: 21200000.00
        },
        {
          month: "2025-12",
          net_cash_flow: 1800000.00,
          ending_balance: 23000000.00
        }
      ],
      annual_summary: {
        total_inflows: 156000000.00,
        total_outflows: 142000000.00,
        net_annual_flow: 14000000.00,
        roi: 9.8
      },
      currency: "HKD"
    },
    {
      scenario_id: "cf-scenario-002",
      scenario_name: "樂觀情境",
      description: "假設市場增長和銷售表現超出預期的情境",
      period_start: "2025-07",
      period_end: "2026-06",
      created_date: "2025-06-01",
      monthly_projections: [
        {
          month: "2025-07",
          net_cash_flow: 1050000.00,
          ending_balance: 16300000.00
        },
        {
          month: "2025-08",
          net_cash_flow: 1350000.00,
          ending_balance: 17650000.00
        },
        {
          month: "2025-09",
          net_cash_flow: 1450000.00,
          ending_balance: 19100000.00
        },
        {
          month: "2025-10",
          net_cash_flow: 1550000.00,
          ending_balance: 20650000.00
        },
        {
          month: "2025-11",
          net_cash_flow: 1650000.00,
          ending_balance: 22300000.00
        },
        {
          month: "2025-12",
          net_cash_flow: 2100000.00,
          ending_balance: 24400000.00
        }
      ],
      annual_summary: {
        total_inflows: 172000000.00,
        total_outflows: 146000000.00,
        net_annual_flow: 26000000.00,
        roi: 17.8
      },
      currency: "HKD"
    },
    {
      scenario_id: "cf-scenario-003",
      scenario_name: "悲觀情境",
      description: "假設市場下滑和銷售表現不及預期的情境",
      period_start: "2025-07",
      period_end: "2026-06",
      created_date: "2025-06-01",
      monthly_projections: [
        {
          month: "2025-07",
          net_cash_flow: 650000.00,
          ending_balance: 15900000.00
        },
        {
          month: "2025-08",
          net_cash_flow: 850000.00,
          ending_balance: 16750000.00
        },
        {
          month: "2025-09",
          net_cash_flow: 950000.00,
          ending_balance: 17700000.00
        },
        {
          month: "2025-10",
          net_cash_flow: 900000.00,
          ending_balance: 18600000.00
        },
        {
          month: "2025-11",
          net_cash_flow: 1000000.00,
          ending_balance: 19600000.00
        },
        {
          month: "2025-12",
          net_cash_flow: 1300000.00,
          ending_balance: 20900000.00
        }
      ],
      annual_summary: {
        total_inflows: 138000000.00,
        total_outflows: 140000000.00,
        net_annual_flow: -2000000.00,
        roi: -1.4
      },
      currency: "HKD"
    }
  ],
  
  // Cash flow forecast KPIs
  cashFlowKPIs: [
    {
      kpi_id: "cf-kpi-001",
      name: "營運現金流比率",
      current_value: 1.25,
      unit: "ratio",
      target_value: 1.2,
      previous_value: 1.18,
      trend: "improving",
      status: "good"
    },
    {
      kpi_id: "cf-kpi-002",
      name: "現金轉換週期",
      current_value: 45,
      unit: "days",
      target_value: 40,
      previous_value: 48,
      trend: "improving",
      status: "good"
    },
    {
      kpi_id: "cf-kpi-003",
      name: "自由現金流",
      current_value: 3500000,
      unit: "HKD",
      target_value: 3000000,
      previous_value: 2800000,
      trend: "improving",
      status: "excellent"
    },
    {
      kpi_id: "cf-kpi-004",
      name: "現金儲備覆蓋率",
      current_value: 3.5,
      unit: "months",
      target_value: 3.0,
      previous_value: 3.2,
      trend: "improving",
      status: "excellent"
    }
  ],
  
  // Sensitivity analysis data
  sensitivityAnalysis: [
    {
      factor_id: "sa-001",
      factor_name: "銷售增長率",
      base_value: 5.0,
      unit: "%",
      scenarios: [
        {
          value: 3.0,
          impact: -8500000,
          description: "銷售增長率下降到3%將導致現金流減少"
        },
        {
          value: 5.0,
          impact: 0,
          description: "基準情境"
        },
        {
          value: 7.0,
          impact: 9200000,
          description: "銷售增長率提高到7%將增加現金流"
        }
      ]
    },
    {
      factor_id: "sa-002",
      factor_name: "原材料成本",
      base_value: 28.0,
      unit: "%",
      scenarios: [
        {
          value: 26.0,
          impact: 6800000,
          description: "原材料成本降低到26%將增加現金流"
        },
        {
          value: 28.0,
          impact: 0,
          description: "基準情境"
        },
        {
          value: 30.0,
          impact: -7200000,
          description: "原材料成本上升到30%將減少現金流"
        }
      ]
    },
    {
      factor_id: "sa-003",
      factor_name: "應收賬款收款天數",
      base_value: 45,
      unit: "天",
      scenarios: [
        {
          value: 40,
          impact: 4500000,
          description: "縮短收款天數將增加現金流"
        },
        {
          value: 45,
          impact: 0,
          description: "基準情境"
        },
        {
          value: 50,
          impact: -4800000,
          description: "延長收款天數將減少現金流"
        }
      ]
    },
    {
      factor_id: "sa-004",
      factor_name: "匯率波動",
      base_value: 7.8,
      unit: "HKD/USD",
      scenarios: [
        {
          value: 7.7,
          impact: -3200000,
          description: "港幣升值將減少出口收入"
        },
        {
          value: 7.8,
          impact: 0,
          description: "基準情境"
        },
        {
          value: 7.9,
          impact: 3500000,
          description: "港幣貶值將增加出口收入"
        }
      ]
    }
  ]
};
